import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { QRCodeCanvas } from "qrcode.react";

interface ModalPreviewQRCodeProps {
  title?: any;
  data?: any;
  itemQRCode?: any
  onCloseQRCodeClick?: () => void;
}

const ModalPreviewQRCode = ({
  title = '',
  data,
  itemQRCode,
  onCloseQRCodeClick,
}: ModalPreviewQRCodeProps) => {
  const { t } = useTranslation();
  let qrCodeRef = React.createRef<any>();

  const handleCloseConfirmClick = () => {
    onCloseQRCodeClick && onCloseQRCodeClick();
  };

  const handleDownload = (name: string = "qrcode") => {
    const canvas = qrCodeRef?.current;
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = name + ".jpg";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
    return;
  };

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={false} size="sx">
        <ModalHeader toggle={handleCloseConfirmClick}>
          {itemQRCode ? itemQRCode?.agency_name : title}
        </ModalHeader>
        <ModalBody>
          <div className="text-center">
            {itemQRCode ? (
              <>
                <QRCodeCanvas
                  value={itemQRCode?.branch_link}
                  size={200}
                  ref={qrCodeRef}
                  style={{ backgroundColor: "white", padding: 20 }}
                />
                <div>
                  {`${t("Referral Code")}: `}
                  <span className="text-primary">{`${itemQRCode?.referral_code}`}</span>
                </div>
                <div className="mb-1">
                  {`${t("Branch Link")}: `}
                  <span className="text-primary" style={{wordWrap: "break-word"}}>{`${itemQRCode?.branch_link}`}</span>
                </div>
                <div
                  className="text-primary text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDownload(itemQRCode?.referral_code)}
                >
                  {t("Download")}
                </div>
              </>
            ) : 
            <>
              {
                data && 
                <>
                  <QRCodeCanvas
                    value={data}
                    size={200}
                    ref={qrCodeRef}
                    style={{ backgroundColor: "white", padding: 20 }}
                  />
                  <div className="mb-1">
                    {`${t("Branch Link")}: `}
                    <span className="text-primary" style={{wordWrap: "break-word"}}>{`${data}`}</span>
                  </div>
                </>
              }
              <div
                className="text-primary text-decoration-underline"
                style={{ cursor: "pointer" }}
                onClick={() => handleDownload()}
              >
                {t("Download")}
              </div>
            </>
          }
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ModalPreviewQRCode;
